import './app/core/i18n'; // i18n — must initialize before React
import '@lemoncloud/react-page-transition/styles.css';
import './styles.css';

import { StrictMode } from 'react';

import * as ReactDOM from 'react-dom/client';

import { ENV } from '@lemoment/shared';

import { App } from './app/app';

// Mock the API in LOCAL (server not yet wired) or when explicitly forced.
const useMocks =
  import.meta.env.VITE_USE_MOCKS === 'true' ||
  (import.meta.env.VITE_USE_MOCKS !== 'false' && ENV === 'LOCAL');

const enableMocks = async (): Promise<void> => {
  if (!useMocks) {
    return;
  }
  const { startMockWorker } = await import('./mocks');
  await startMockWorker();
};

void enableMocks().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  );

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
